import React from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import MediaPicker from '../MediaPicker';

const counter = (value, max) => `${value.length}/${max}`;

/**
 * Campos do e-mail de um envio: nome, assunto, preheader, abertura, aviso no sino e vídeo.
 * @param {{ form: Object, setField: Function, number: number }} props
 */
function EditionFields({ form, setField, number }) {
  const videoLabel = `Vídeo envio #${number}`;

  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <TextField
        size="small"
        label="Nome do envio"
        placeholder="Semana 42"
        value={form.name}
        onChange={(e) => setField('name', e.target.value)}
        helperText="Só para você se localizar"
        inputProps={{ maxLength: 120 }}
      />
      <TextField
        size="small"
        label="Assunto"
        value={form.subject}
        onChange={(e) => setField('subject', e.target.value)}
        helperText={counter(form.subject, 150)}
        inputProps={{ maxLength: 150 }}
      />
      <TextField
        size="small"
        label="Texto de apoio"
        value={form.preheader}
        onChange={(e) => setField('preheader', e.target.value)}
        helperText={`Aparece ao lado do assunto na caixa de entrada · ${counter(form.preheader, 200)}`}
        inputProps={{ maxLength: 200 }}
      />
      <TextField
        size="small"
        label="Abertura"
        value={form.intro}
        onChange={(e) => setField('intro', e.target.value)}
        helperText="Primeiro parágrafo do e-mail"
        multiline
        minRows={3}
      />
      <FormControlLabel
        control={<Switch checked={form.notify_bell} onChange={(e) => setField('notify_bell', e.target.checked)} />}
        label="Avisar no sino quando sair"
      />

      <Box sx={{ pt: 1, borderTop: '1px solid #EEF1F6', display: 'grid', gap: 1.5 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>Vídeo (opcional)</Typography>
        <MediaPicker kind="video" label="Vídeo" value={form.video_media_id} onChange={(id) => setField('video_media_id', id)} uploadLabel={videoLabel} />
        <MediaPicker kind="poster" label="Capa do vídeo" value={form.poster_media_id} onChange={(id) => setField('poster_media_id', id)} uploadLabel={`Capa envio #${number}`} disabled={!form.video_media_id} />
        <MediaPicker kind="captions" label="Legenda" value={form.captions_media_id} onChange={(id) => setField('captions_media_id', id)} uploadLabel={`Legenda envio #${number}`} disabled={!form.video_media_id} />
      </Box>
    </Box>
  );
}

export default EditionFields;
